// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1mdCC","link":"Header_link__zrVm3","logo":"Header_logo__NotON","content":"Header_content__rqYMB"};